(function () {
    'use strict';

    function main() {
        var controller = {
            init: function () {
                WhistleOut.getAds('Tablets');
            }
        };

        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
